import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuantityAdjustmentsService {


  url = environment.serverAPI5 + "/api/adjustment";

  constructor(private http: HttpClient) { }

  getAllAdjustment(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllAdjustmentDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getAdjustmentById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditAdjustment(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, warehouses);
  }

  AdjustmentSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteById(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  downloadQuantityAdjustmentTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  downloadAudjustmentReport(Page: number, size: number, sort, selectionAudjustment): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionAudjustment, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
}
